import gql from 'graphql-tag';

import dokkioTagFragment from './dokkioTagFragment';

export const acceptedSuggestionsFragment = gql`
  fragment acceptedSuggestionsFragment on AcceptedSuggestions {
    dokkioClass
    acceptedDokkioTags {
      ...dokkioTagFragment
    }
  }
  ${dokkioTagFragment}
`;
export default acceptedSuggestionsFragment;
